import type {ContentType} from '@deezer/next/services/types/contentType';

export default {
	searchItem: (contentType: ContentType) => `/search/${contentType}`,
	searchAll: '/search',
};
